// modules/Shop/ShopUI.js
// 商店UI模块

import BackgroundHelper from '../BackgroundHelper.js';
import UIStyleHelper from '../UIStyleHelper.js';

export default class ShopUI {
    constructor(scene) {
        this.scene = scene;
        this.bg = null;
        this.title = null;
        this.moneyText = null;
        this.itemList = null;
        this.itemDetails = null;
        this.helpText = null;
        this.modeText = null;
        this.messageText = null;
    }
    
    /**
     * 创建背景
     * @param {string} npcName - NPC名称
     */
    createBackground(npcName) {
        // 半透明背景（使用BackgroundHelper）
        this.bg = BackgroundHelper.createSemiTransparentBackground(this.scene, 0.8);
        
        // 商店标题（使用UIStyleHelper）
        this.title = UIStyleHelper.createSubtitle(
            this.scene,
            `${npcName}的商店`,
            this.scene.cameras.main.centerX,
            30,
            { fill: '#ffcc00', fontFamily: 'Arial' }
        );
    }
    
    /**
     * 创建商店UI
     */
    createShopUI() {
        // 商品列表区域
        this.itemList = this.scene.add.container(
            this.scene.cameras.main.width * 0.25,
            this.scene.cameras.main.height * 0.3
        );
        
        // 商品详情区域
        this.itemDetails = this.scene.add.container(
            this.scene.cameras.main.width * 0.65,
            this.scene.cameras.main.height * 0.5
        );
        
        // 操作提示
        this.helpText = this.scene.add.text(
            this.scene.cameras.main.centerX,
            this.scene.cameras.main.height - 50,
            'W/S:移动 空格键:选择/确认 ESC:返回',
            {
                fontSize: '14px',
                fill: '#aaaaaa',
                fontFamily: 'Arial'
            }
        ).setOrigin(0.5);
        
        // 模式切换提示
        this.modeText = this.scene.add.text(
            this.scene.cameras.main.width * 0.5,
            60,
            '',
            {
                fontSize: '16px',
                fill: '#ffff00',
                fontFamily: 'Arial',
                fontWeight: 'bold'
            }
        ).setOrigin(0.5);
    }
    
    /**
     * 创建金钱显示
     * @param {number} money - 玩家金钱
     */
    createMoneyDisplay(money) {
        // 玩家金钱显示（使用UIStyleHelper）
        this.moneyText = UIStyleHelper.createMoneyText(
            this.scene,
            money,
            this.scene.cameras.main.width * 0.1,
            30
        );
    }
    
    /**
     * 更新金钱显示
     * @param {number} money - 玩家金钱
     */
    updateMoneyDisplay(money) {
        if (this.moneyText) {
            this.moneyText.setText(`金钱: ${money} G`);
        }
    }
    
    /**
     * 更新模式提示
     * @param {string} mode - 当前模式
     */
    updateModeText(mode) {
        if (!this.modeText) return;
        
        const modeTexts = {
            'menu': '请选择操作',
            'browse': '购买模式',
            'sell': '出售模式',
            'confirm': '确认购买',
            'sellConfirm': '确认出售'
        };
        
        this.modeText.setText(modeTexts[mode] || '');
    }
    
    /**
     * 显示消息
     * @param {string} text - 消息文本
     * @param {string} color - 文本颜色
     */
    showMessage(text, color = '#ffffff') {
        if (this.messageText) {
            this.messageText.destroy();
        }
        
        // 创建消息文本
        this.messageText = this.scene.add.text(
            this.scene.cameras.main.centerX,
            this.scene.cameras.main.height - 100,
            text,
            {
                fontSize: '16px',
                fill: color,
                fontFamily: 'Arial',
                align: 'center',
                backgroundColor: '#000000',
                padding: { x: 10, y: 5 },
                wordWrap: { width: 360 }
            }
        ).setOrigin(0.5);
        this.messageText.setScrollFactor(0);
        this.messageText.setDepth(10002); // 确保在菜单之上
    }
    
    /**
     * 清空列表
     */
    clearLists() {
        if (this.itemList) {
            this.itemList.removeAll(true);
        }
        if (this.itemDetails) {
            this.itemDetails.removeAll(true);
        }
    }
    
    /**
     * 销毁UI
     */
    destroy() {
        if (this.bg) this.bg.destroy();
        if (this.title) this.title.destroy();
        if (this.moneyText) this.moneyText.destroy();
        if (this.itemList) this.itemList.destroy();
        if (this.itemDetails) this.itemDetails.destroy();
        if (this.helpText) this.helpText.destroy();
        if (this.modeText) this.modeText.destroy();
        if (this.messageText) this.messageText.destroy();
    }
}

